import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormValue } from '../../../../../form-controls/entities/form-value.entity';

export function UrlInputValidator(control: AbstractControl): ValidationErrors | null {
    const formValue: FormValue | string | undefined = control.value;
    let validUrl = false;

    if (!formValue || (typeof formValue !== 'string' && !formValue.value)) {
        return null;
    }

    try {
        const value: string = typeof formValue === 'string' ? formValue : formValue.value;
        const url = new URL(value);

        // regex check that checks if has x of any ca . and a domain
        const urlRegex: RegExp = /^(https?:\/\/)?(www\.)?.*\..{2,}/;
        validUrl = urlRegex.test(value);
    } catch (err) {}

    return validUrl ? null : { invalidUrl: true, message: 'profile-form.url-input-field.invalid-url' };
}
